import DealDetails from 'pages/Dashboard/Deals/DealDetails';
import DealEdit from 'pages/Dashboard/Deals/DealEdit';
import DealNew from 'pages/Dashboard/Deals/DealNew';
import { Tasks } from 'pages/Dashboard/Tasks';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { AdminPanel } from '../components/featured/AdminPanel/AdminPanel';
import AsanaProjectDetails from '../components/featured/Asana/AsanaProjectDetails/AsanaProjectDetails';
import ClientSelected from '../components/featured/Client/ClientSelected/ClientSelected';
import TeamSelected from '../components/featured/Team/TeamSelected';
import ZoomInfoSelected from '../components/featured/ZoomInfo/ZoomInfoSelected/ZoomInfoSelected';
import MainLayout from '../layout/layout';
import ErrorComponent from '../pages/404/404';
import Asana from '../pages/Asana/Asana';
import { SelectedRoleAndPermission } from '../pages/Dashboard/Admin/SelectedRoleAndPermission';
import Client from '../pages/Dashboard/Client/Client';
import Dashboard from '../pages/Dashboard/Dashboard/Dashboard';
import { Deals } from '../pages/Dashboard/Deals';
import Team from '../pages/Dashboard/Team/Team';
import EmailVerification from '../pages/EmailVerification/EmailVerification';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import LoginScreen from '../pages/LoginScreen/LoginScreen';
import RegisterScreen from '../pages/Register/Register';
import RegisterForm from '../pages/RegisterForm/RegisterForm';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import Privacy from '../pages/Terms-Privacy/Privacy';
import Terms from '../pages/Terms-Privacy/Terms';
import ZoomInfo from '../pages/ZoomInfo/ZoomInfo';
import { loader, ProtectedRoute, ValidateNewUserRoute } from './ProtectedRoutes';
import RoutePaths from './RoutePaths';
import Leads from 'pages/Dashboard/Leads';
import SocialInsightsPage from 'components/featured/Leads/SocialInsights';
import Contacts from 'pages/Dashboard/Contacts';
const Root = () => {
  return <Navigate to={RoutePaths.Login} />;
};
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' errorElement={<ErrorComponent />}>
      <Route index element={<Root />} />
      <Route path={RoutePaths.Login} element={<LoginScreen />} />
      <Route
        path={RoutePaths.RegisterForm}
        element={
          <ValidateNewUserRoute>
            <RegisterForm />
          </ValidateNewUserRoute>
        }
      />

      <Route path={RoutePaths.EmailVerification} element={<EmailVerification />} />
      <Route path={RoutePaths.Register} element={<RegisterScreen />} />
      <Route path={RoutePaths.ResetPassword} element={<ResetPassword />} />
      <Route path={RoutePaths.ForgotPassword} element={<ForgotPassword />} />
      <Route path={RoutePaths.Terms} element={<Terms />} />
      <Route path={RoutePaths.Privacy} element={<Privacy />} />
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
        loader={loader}
      >
        <Route path={RoutePaths.Home} element={<Dashboard />} />
        <Route path={`${RoutePaths.Home}/admin`} element={<AdminPanel />} />
        <Route path={`${RoutePaths.Home}/admin/role/:id`} element={<SelectedRoleAndPermission />} />

        <Route path={`${RoutePaths.Leads}`} element={<Leads />} />

        <Route path={RoutePaths.Client} element={<Client />} />
        <Route path={`${RoutePaths.Client}/huddle/:id`} element={<ClientSelected />} />
        <Route path={`${RoutePaths.Client}/:id`} element={<ClientSelected />} />

        <Route path={RoutePaths.Team} element={<Team />} />
        <Route path={`${RoutePaths.Team}/:id`} element={<TeamSelected />} />

        <Route path={RoutePaths.Tasks} element={<Tasks />} />

        <Route path={RoutePaths.Deals}>
          <Route index element={<Deals />} />
          <Route path={`new`} element={<DealNew />} />
          <Route path={`:id/edit`} element={<DealEdit />} />
          <Route path={`:id`} element={<DealDetails />} />
        </Route>

        <Route path={RoutePaths.Asana} element={<Asana />} />
        <Route path={`${RoutePaths.Asana}/:id`} element={<AsanaProjectDetails />} />

        <Route path={RoutePaths.ZoomInfo} element={<ZoomInfo />} />
        <Route path={`${RoutePaths.ZoomInfo}/:id`} element={<ZoomInfoSelected />} />

        <Route path='/leads/new-lead/social-insights' element={<SocialInsightsPage />} />
        <Route path={RoutePaths.Contacts} element={<Contacts />} />
      </Route>
    </Route>,
  ),
);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
